import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { AboutComponent } from './about/about.component';
import { MainComponent } from './main/main.component';
import { LinesComponent } from './lines/lines.component';
import { DetailsComponent } from './lines/details/details.component';
import { StopsComponent } from './stops/stops.component';
import { DetailsStopComponent } from './stops/details-stop/details-stop.component';

import { LinesService } from './lines/lines.service';
import { StopsService } from './stops/stops.service';




@NgModule({
  declarations: [
    AppComponent,
    AboutComponent,
    MainComponent,
    LinesComponent,
    DetailsComponent,
    StopsComponent,
    DetailsStopComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpClientModule,
    RouterModule.forRoot([
      {
        path: '',
        component: MainComponent
      },
      {
        path: 'stops',
        component: StopsComponent
      },
      {
        path: 'stops/:id',
        component: DetailsStopComponent
      },
      {
        path: 'lines',
        component: LinesComponent
      },
      {
        path: 'lines/:id',
        component: DetailsComponent
      },
      {
        path: 'about',
        component: AboutComponent
      }
    ])
  ],
  providers: [LinesService, StopsService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts